var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 1.99996C10.5267 1.99996 12.78 3.41996 13.88 5.66663C12.78 7.91329 10.5267 9.33329 8.00002 9.33329C5.47335 9.33329 3.22002 7.91329 2.12002 5.66663C3.22002 3.41996 5.47335 1.99996 8.00002 1.99996ZM8.00002 0.666626C4.66669 0.666626 1.82002 2.73996 0.666687 5.66663C1.82002 8.59329 4.66669 10.6666 8.00002 10.6666C11.3334 10.6666 14.18 8.59329 15.3334 5.66663C14.18 2.73996 11.3334 0.666626 8.00002 0.666626ZM8.00002 3.99996C8.92002 3.99996 9.66669 4.74663 9.66669 5.66663C9.66669 6.58663 8.92002 7.33329 8.00002 7.33329C7.08002 7.33329 6.33335 6.58663 6.33335 5.66663C6.33335 4.74663 7.08002 3.99996 8.00002 3.99996ZM8.00002 2.66663C6.34669 2.66663 5.00002 4.01329 5.00002 5.66663C5.00002 7.31996 6.34669 8.66663 8.00002 8.66663C9.65335 8.66663 11 7.31996 11 5.66663C11 4.01329 9.65335 2.66663 8.00002 2.66663Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.2cd8794e.svg";
export { ForwardRef as ReactComponent };